"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputWrapper = exports.TextInput = exports.IconWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreMixins = require("@vfuk/core-mixins");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/* stylelint-disable property-no-vendor-prefix */
var TextInputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TextInputstyle__TextInputWrapper",
  componentId: "sc-bg77me-0"
})(function () {
  return (0, _styledComponents.css)(["position:relative;"]);
});
exports.TextInputWrapper = TextInputWrapper;
var TextInput = _styledComponents["default"].input.withConfig({
  displayName: "TextInputstyle__TextInput",
  componentId: "sc-bg77me-1"
})(function (props) {
  var stateFromTheme = props.state && props.theme.formFields.state[props.state];
  return (0, _styledComponents.css)(["color:", ";transition:0.4s box-shadow ease;border:", " ", " ", ";border-radius:", ";background-color:", ";width:100%;", " ", " ", " ", " ", ";::-ms-reveal{display:none;}"], props.theme.formFields.color, props.theme.formFields.border.width, props.theme.formFields.border.style, props.theme.formFields.border.color, props.theme.formFields.border.radius, props.theme.formFields.backgroundColor, (0, _coreMixins.advancedSpacing)('padding', [2, 3]), _coreMixins.typography.heading(1, false), props.state && stateFromTheme && (0, _styledComponents.css)(["color:", ";background-color:", ";border-color:", ";border-width:", ";"], stateFromTheme.color, stateFromTheme.backgroundColor, stateFromTheme.border.color, stateFromTheme.border.width), props.state === 'disabled' && (0, _styledComponents.css)(["cursor:not-allowed;&:focus{caret-color:transparent;}"]), (0, _coreMixins.applyFocus)());
});
exports.TextInput = TextInput;
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TextInputstyle__IconWrapper",
  componentId: "sc-bg77me-2"
})(function () {
  return (0, _styledComponents.css)(["height:100%;display:flex;align-items:center;position:absolute;top:0;right:0;pointer-events:none;", ""], (0, _coreMixins.spacing)('padding-right', 3));
});
exports.IconWrapper = IconWrapper;